import type { FC } from 'react'

import { config } from '@skytech/config'
import { getEnvironmentBadgeLabel } from '@skytech/config/environmentBadge'
import { LanguageChoiceButtons } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'

import Text from '@/app/translations/Text'
import { LocalDate } from '@/components/LocalDate'
import { useOnboardingForm } from '@/forms/hooks'
import { getFormatterMobileNumber } from '@/util/formatters/text'

import { useAppContext } from './index.context'
import queries from './queries'
import appResources from './resources'
import type { FormType } from './types'

import './Header.styles.scss'

const formTypeTextFromType = (formType: FormType) => {
  switch (formType) {
    case 'TERMINATION':
      return <Text id="Oppsigelse" />
    case 'PORTING':
      return <Text id="Nytt abonnement" />
    case 'INJURY_REPORT':
      return <Text id="Skademelding" />
    default:
      return ''
  }
}

export const Header: FC = () => {
  const { locale, setLocale } = useAppContext()
  const { activationDate } = useOnboardingForm().data
  const { data } = useQuery(queries.form(), appResources.getForm)

  if (!data) return null

  const { formType, userName, userNumber, userEmail } = data
  const environmentBadgeLabel = getEnvironmentBadgeLabel(config.ENVIRONMENT)

  return (
    <>
      <LanguageChoiceButtons
        locale={locale}
        onChangeLocale={setLocale}
        // todo: remove ! when the .flex classname is refactored in the app
        className="-mt-2 flex justify-start sm:!hidden"
      />

      <header className="flex justify-between">
        <div>
          <h1>{formTypeTextFromType(formType)}</h1>
          {environmentBadgeLabel && (
            <div className="development-indication">{environmentBadgeLabel}</div>
          )}
          {userName && <h4>{userName}</h4>}
          {userNumber && <h5>{getFormatterMobileNumber(userNumber)}</h5>}
          {userEmail && <h5>{userEmail}</h5>}
          {activationDate && (
            <h4>
              <Text
                id="Aktiveringsdato: {activationDate}"
                activationDate={<LocalDate date={activationDate} />}
              />
            </h4>
          )}
        </div>
        <LanguageChoiceButtons
          locale={locale}
          onChangeLocale={setLocale}
          className="hidden sm:flex"
        />
      </header>
    </>
  )
}
